<template>
  <div>
    <div
      style="
        font-family: arial !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div style="text-align: center; font-size: 30px">
        Vista previa de impresión de Ticket  (
          {{ dataProps.data.header.InvoiceType == 'FCF' ? 'Factura consumidor final' : ''}}
          {{ dataProps.data.header.InvoiceType == 'CCF' ? 'Factura crédito fiscal' : ''}}
          )
      </div>
      <br />
      <div style="text-align: center;">
        <button class="btnclean" style="font-size: 18px" @click="Print()">
          Imprimir
        </button>
        &nbsp;&nbsp;
        <button class="btnclean" style="font-size: 18px" @click="Download()">
          Descargar
        </button>
        &nbsp;&nbsp;
        <button
          v-if="!hideQr"
          class="btnclean"
          style="font-size: 18px"
          @click="sendMail()"
        >
          Enviar Correo
        </button>
        &nbsp;&nbsp;
        <button
          v-if="!hideQr"
          class="btnclean"
          style="font-size: 18px"
          @click="downLoadJSON()"
        >
          Descargar JSON
        </button>
        <download-invalidation-json :header="dataProps.data.header" />
        &nbsp;&nbsp;&nbsp;&nbsp;
        <button
          v-if="!hideQr"
          style="font-size: 18px"
          @click="$emit('input', 'regular')"
        >
          Ver en formato normal
        </button>
      </div>
      <div v-if="loading" style="text-align: center">Cargando...</div>
    </div>
    <div
      style="
        font-family: arial !important;
        margin-top: 10px;
        margin-bottom: 10px;
      "
    >
      <div v-if="mailLabel">{{ mailLabel }}</div>
    </div>

    <div
      class="book"
      style="
        margin: 0;
        padding: 0;
        background-color: rgb(105, 105, 105);
        font-family: arial !important;
        padding-top: 20px;
        padding-bottom: 20px;
      "
    >
      <div
        style="
          margin: 0 auto;
          width: 400px;
          display: flex;
          justify-content: center;
          font-size: 10pt;
        "
      >
        <div
          ref="dataprint"
          style="margin: 0 !important; padding: 0 !important; font-family: Arial !important;"
        >
          <div style="position: relative; width: 325px; background: white">
            <hr />
            <div class="subpage" style="padding-top: 20px; overflow: hidden">
              <div v-if="keyMaster == 'cc8a8458a6b9a580a055095006d2de66' || keyMaster == 'b5df5bc0d3cbf62c52817e7bddc09ff3' || keyMaster == 'e9aaa6a6458a982a4b01c253a76ae58d'" :style="ticketformat3nstar ? { marginLeft: '00px', marginRight: '43px' } : { marginLeft: '23px', marginRight: '33px' }">
                <div
                  v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO RECHAZADO POR HACIENDA
                  </h3>
                </div>

                <div
                  v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO INVALIDADO POR HACIENDA
                  </h3>
                </div>

                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      <b>{{
                        dataProps.data.user.business != undefined ||
                        dataProps.data.user.business != null
                          ? dataProps.data.user.business.toUpperCase()
                          : ""
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        color: white;
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      <img
                        v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
                        style="max-width: 200px; height: 50px"
                        :src="dataProps.data.branch.BranchLogoPath"
                        crossorigin="anonymous"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      RAZÓN SOCIAL:
                      {{
                        dataProps.data.branch.BusinessBillingName !=
                          undefined ||
                        dataProps.data.branch.BusinessBillingName != null
                          ? dataProps.data.branch.BusinessBillingName.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      ACTIVIDAD:
                      {{
                        dataProps.data.header.EmisorDescActividad !=
                          undefined ||
                        dataProps.data.header.EmisorDescActividad != null
                          ? dataProps.data.header.EmisorDescActividad.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      DIRECCIÓN:
                      {{
                        dataProps.data.branch.BranchLegalAddress != undefined ||
                        dataProps.data.branch.BranchLegalAddress != null
                          ? dataProps.data.branch.BranchLegalAddress.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      TÉLEFONO:
                      {{
                        dataProps.data.branch.BranchPhone != undefined ||
                        dataProps.data.branch.BranchPhone != null
                          ? dataProps.data.branch.BranchPhone.toUpperCase()
                          : ""
                      }}
                      <br />
                      WHATSAPP:
                      {{
                        dataProps.data.branch.BranchMobile ||
                        dataProps.data.branch.BranchManagerMobile ||
                        dataProps.data.branch.BranchContactMobile
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      E-MAIL: {{ dataProps.data.branch.BranchEmail }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      NIT: {{ BillingNit }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      NRC: {{ BillingNrc }}
                    </td>
                  </tr>
                </table>
                <br/><hr/>
                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      {{ dataProps.data.header.InvoiceType == 'FCF' ? 'FACTURA CONSUMIDOR FINAL' : '' }}
                      {{ dataProps.data.header.InvoiceType == 'CCF' ? 'FACTURA CRÉDITO FISCAL' : '' }}
                    </td>
                  </tr>
                  <br/>
                  <tr>
                    <div style="display: flex; justify-content: space-between;">
                      <span>Fecha emisión: {{ dataProps.data.header.InvoiceDate }}</span>
                      <span>Hora: {{ dataProps.data.header.IdentificacionHorEmi }}</span>
                    </div>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      COD. GENERACIÓN:
                      <b>{{ dataProps.data.header.CodigoGeneracion }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      SELLO RECEPCIÓN:
                      <b>{{ dataProps.data.header.SelloRecepcion }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      NUM. CONTROL:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.NumeroControl }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      CORRELATIVO FACTURA:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.ID_Invoice }}</b>
                    </td>
                  </tr>
                  <tr v-if="ShowCorrelativeControl">
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      CORRELATIVO INTERNO:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.InvoiceType + "-" + dataProps.data.header.Correlative_ID_Invoice }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      MÓDELO DE FACTURACIÓN:
                      {{
                        dataProps.data.dteJson.IdentificacionTipoModelo == 1
                          ? "Previo"
                          : ""
                      }}
                      {{
                        dataProps.data.dteJson.IdentificacionTipoModelo == 2
                          ? "Diferido"
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      TIPO DE TRANSMISIÓN:
                      {{
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                          ? "Normal"
                          : ""
                      }}
                      {{
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                          ? "Por contingencía"
                          : ""
                      }}
                    </td>
                  </tr>
                </table>
                <br/><hr/>
                <table 
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top; 
                    text-align: center;"
                  >
                  <tr>
                    <td style="width: 25%;">Cant.</td>
                    <td style="width: 25%;">P.<br/>Unit.</td>
                    <td style="width: 25%;">Desc.<br/>Por Item</td>
                    <td style="width: 25%;">SubTotal</td>
                  </tr>
                </table>
                <table
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <!-- Itera sobre cada item en dataProps.data.body -->
                  <tr v-for="(item, index) in dataProps.data.body" :key="index">
                    <hr/>
                    <table style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  ">
                    <tr>
                      <td colspan="4">
                        {{ item.ItemDescription + " " + (parseFloat(item.ItemGravada) > 0 ? "(G)" : "") + (parseFloat(item.ItemExenta) > 0 ? "(E)" : "") + (parseFloat(item.ItemNoSuj) > 0 ? "(NS)" : "") }}
                      </td>
                    </tr>
                    <tr>
                      <td style="width: 25%; text-align: center;">
                        {{ item.ItemQuantity }}
                      </td>

                      <td style="width: 25%; text-align: right;">
                        {{dataProps.data.header.InvoiceCurrency}}
                        {{numberWithCommas(
                            parseFloat(item.ItemUnitPrice)
                          )
                        }}
                      </td>
                      <td style="width: 25%; text-align: right;">
                        {{dataProps.data.header.InvoiceCurrency}}
                        {{numberWithCommas(
                            parseFloat(item.ItemDiscount)
                          )
                        }}
                      </td>
                      <td style="width: 25%; text-align: right;">
                        {{dataProps.data.header.InvoiceCurrency}}
                        {{parseFloat(item.ItemGravada) > 0 ? numberWithCommas(parseFloat(item.ItemGravada)) : ""}}
                        {{parseFloat(item.ItemExenta) > 0 ? numberWithCommas(parseFloat(item.ItemExenta)) : ""}}
                        {{parseFloat(item.ItemNoSuj) > 0 ? numberWithCommas(parseFloat(item.ItemNoSuj)) : ""}}
                      </td>
                    </tr>
                    </table>
                  </tr>
                  
                </table>
                <hr />
                <table
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td style=" width: 75%">
                      Suma No Sujeta:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalNoSuj
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Suma Exento:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalExenta
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Suma Gravado:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalGravada
                          )
                        )
                      }}
                    </td>
                  </tr>
                </table>
                <hr/>
                <table
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td style=" width: 75%">
                      Suma Total de Operaciones:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceSubTotal
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Monto global Desc., Rebajas y otros a vtas. no sujetas:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceDescuNoSuj
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Monto global Desc., Rebajas y otros a vtas. Exentas:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceDescuExenta
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Monto global Desc., Rebajas y otros a vtas. gravadas:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceDescuGravada
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Sub-Total:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceSubTotal
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      IVA Retenido (1%):
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceIvaRete1
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      IVA Percibido (1%):
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceIvaPerce1
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Retencion Renta:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceReteRenta
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Total a Pagar:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalPagar
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Condicion de Pago:
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceStatusDescription }}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Efectivo
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }} {{cash}}
                    </td>
                  </tr>
                  <tr>
                    <td style=" width: 75%">
                      Cambio
                    </td>
                    <td style=" width: 25%; text-align: right;">
                      {{ dataProps.data.header.InvoiceCurrency
                      }} {{change}}
                    </td>
                  </tr>
                </table>
                <hr/>
                <table style="
                  font-size: 7pt;
                  border-collapse: collapse;
                  width: 100%;
                  vertical-align: top;
                ">
                  <tr>
                    <td>Valor en Letras: {{ dataProps.data.header.InvoiceTotalLetras }}</td>
                  </tr>
                </table>
                <hr/>
                <table style="
                  font-size: 7pt;
                  border-collapse: collapse;
                  width: 100%;
                  vertical-align: top;
                ">
                  <tr>
                    <td style="text-align: center;">(G)- GRAVADO (E)- EXENTO (NS)- NO SUJETO</td>
                  </tr>
                </table>
                <br/>
                <table style="
                  font-size: 7pt;
                  border-collapse: collapse;
                  width: 100%;
                  vertical-align: top;
                ">
                  <tr>
                    <td><b>Responsable por parte del emisor:</b></td>
                    <td
                      style="
                        text-align: center;
                        vertical-align: top;
                        width: 25%;
                      "
                      rowspan="16"
                    >
                      <img
                        ref="qrcode"
                        :src="urlQr"
                        style="height: 100px"
                        crossorigin="anonymous"
                      />
                    </td>
                  </tr>
                  <tr>
                    <td>{{ dataProps.data.header.InvoiceExtNombEntrega || dataProps.data.header.UserName }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>N. Documento:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{ dataProps.data.header.InvoiceExtDocuEntrega }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>Responsable por parte del receptor:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{
                        dataProps.data.header.InvoiceExtNombRecibe ||
                        dataProps.data.header.InvoiceName != undefined ||
                        dataProps.data.header.InvoiceName != null
                          ? dataProps.data.header.InvoiceName.toUpperCase()
                          : ""
                      }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>Razon social por parte del receptor:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{
                        dataProps.data.header.InvoiceName != undefined ||
                        dataProps.data.header.InvoiceName != null
                          ? dataProps.data.header.InvoiceName.toUpperCase()
                          : ""
                      }}</td>
                      <td></td>
                  </tr>
                  <tr>
                    <td><b>Direccion por parte del receptor:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{
                        dataProps.data.header.InvoiceAddress != undefined ||
                        dataProps.data.header.InvoiceAddress != null
                          ? dataProps.data.header.InvoiceAddress.toUpperCase()
                          : ""
                      }}</td>
                      <td></td>
                  </tr>
                  <tr>
                    <td><b>NIT receptor:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{ dataProps.data.header.InvoiceNIT }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>DUI receptor:</b></td>
                  </tr>
                  <tr>
                    <td>{{ dataProps.data.header.InvoiceDUI }}</td>
                    <td></td>
                  </tr>
                  <tr>
                    <td><b>Entidad de receptor:</b></td>
                    <td></td>
                  </tr>
                  <tr>
                    <td>{{ dataProps.data.header.InvoiceEntity }}</td>
                    <td></td>
                  </tr>
                </table>
              </div>
              <div v-else :style="(keyMaster == 'fdea701deefc2f8a21a9dfcd2b5166ca' || keyMaster == 'fe9f16b15a2d0bc1ad64a56efb4abfda' || keyMaster == '579a13b4a79db357b608b247053fc89d' || keyMaster == 'cc8a8458a6b9a580a055095006d2de66' || keyMaster == 'e9aaa6a6458a982a4b01c253a76ae58d' || keyMaster == 'b5df5bc0d3cbf62c52817e7bddc09ff3' || ticketformat3nstar) ? { marginLeft: '00px', marginRight: '43px' } : { marginLeft: '23px', marginRight: '33px' }">
                <div v-if="hideQr" style="width: 100%; background-color: red">
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO SIN VALIDEZ LEGAL
                  </h3>
                </div>

                <div
                  v-if="dataProps.data.header.FeMhEstado == 'RECHAZADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO RECHAZADO POR HACIENDA
                  </h3>
                </div>

                <div
                  v-if="dataProps.data.header.FeMhEstado == 'INVALIDADO'"
                  style="width: 100%; background-color: red"
                >
                  <h3 style="color: white; text-align: center">
                    DOCUMENTO INVALIDADO POR HACIENDA
                  </h3>
                </div>

                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      <b>{{
                        dataProps.data.user.business != undefined ||
                        dataProps.data.user.business != null
                          ? dataProps.data.user.business.toUpperCase()
                          : ""
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        color: white;
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      <img
                        v-if="dataProps.data.branch?.BranchLogoPath != null && dataProps.data.branch?.BranchLogoPath != '' && dataProps.data.branch?.BranchLogoPath != 'null'"
                        style="max-width: 200px; height: 50px"
                        :src="dataProps.data.branch.BranchLogoPath"
                        crossorigin="anonymous"
                      />
                    </td>
                  </tr>

                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      RAZÓN SOCIAL:
                      {{
                        dataProps.data.branch.BusinessBillingName !=
                          undefined ||
                        dataProps.data.branch.BusinessBillingName != null
                          ? dataProps.data.branch.BusinessBillingName.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      ACTIVIDAD:
                      {{
                        dataProps.data.header.EmisorDescActividad !=
                          undefined ||
                        dataProps.data.header.EmisorDescActividad != null
                          ? dataProps.data.header.EmisorDescActividad.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      DIRECCIÓN:
                      {{
                        dataProps.data.branch.BranchLegalAddress != undefined ||
                        dataProps.data.branch.BranchLegalAddress != null
                          ? dataProps.data.branch.BranchLegalAddress.toUpperCase()
                          : ""
                      }}
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      TÉLEFONO:
                      {{
                        dataProps.data.branch.BranchPhone != undefined ||
                        dataProps.data.branch.BranchPhone != null
                          ? dataProps.data.branch.BranchPhone.toUpperCase()
                          : ""
                      }}
                      <br />
                      WHATSAPP:
                      {{
                        dataProps.data.branch.BranchMobile ||
                        dataProps.data.branch.BranchManagerMobile ||
                        dataProps.data.branch.BranchContactMobile
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      E-MAIL: {{ dataProps.data.branch.BranchEmail }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      NIT: {{ BillingNit }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      NRC: {{ BillingNrc }}
                    </td>
                  </tr>
                </table>
                <hr />
                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <div style="display: flex; justify-content: space-between;">
                      <span>Fecha emisión: {{ dataProps.data.header.InvoiceDate }}</span>
                      <span>Hora: {{ dataProps.data.header.IdentificacionHorEmi }}</span>
                    </div>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      {{ dataProps.data.header.InvoiceType == 'FCF' ? 'FACTURA CONSUMIDOR FINAL' : '' }}
                      {{ dataProps.data.header.InvoiceType == 'CCF' ? 'FACTURA CRÉDITO FISCAL' : '' }}
                    </td>
                  </tr>
                  <tr v-if="!hideQr">
                    <td
                      style="
                        text-align: center;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      <img
                        ref="qrcode"
                        :src="urlQr"
                        style="height: 150px"
                        crossorigin="anonymous"
                      />
                    </td>
                    <br />
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      COD. GENERACIÓN:
                      <b>{{ dataProps.data.header.CodigoGeneracion }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      SELLO RECEPCIÓN:
                      <b>{{ dataProps.data.header.SelloRecepcion }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      NUM. CONTROL:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.NumeroControl }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      CORRELATIVO FACTURA:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.ID_Invoice }}</b>
                    </td>
                  </tr>
                  <tr v-if="ShowCorrelativeControl">
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      CORRELATIVO INTERNO:
                      <b style="font-size: 8pt;">{{ dataProps.data.header.InvoiceType + "-" + dataProps.data.header.Correlative_ID_Invoice }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      MÓDELO DE FACTURACIÓN:
                      {{
                        dataProps.data.dteJson.IdentificacionTipoModelo == 1
                          ? "Previo"
                          : ""
                      }}
                      {{
                        dataProps.data.dteJson.IdentificacionTipoModelo == 2
                          ? "Diferido"
                          : ""
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      TIPO DE TRANSMISIÓN:
                      {{
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 1
                          ? "Normal"
                          : ""
                      }}
                      {{
                        dataProps.data.dteJson.IdentificacionTipoOperacion == 2
                          ? "Por contingencía"
                          : ""
                      }}
                    </td>
                  </tr>
                </table>
                <hr />
                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                      "
                    >
                      DATOS DEL RECEPTOR
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      RAZÓN SOCIAL:
                      <b>{{
                        dataProps.data.header.InvoiceName != undefined ||
                        dataProps.data.header.InvoiceName != null
                          ? dataProps.data.header.InvoiceName.toUpperCase()
                          : ""
                      }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      DIRECCIÓN:
                      <b>{{
                        dataProps.data.header.InvoiceAddress != undefined ||
                        dataProps.data.header.InvoiceAddress != null
                          ? dataProps.data.header.InvoiceAddress.toUpperCase()
                          : ""
                      }}</b>
                    </td>
                  </tr>
                  <br />
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      NIT: <b>{{ dataProps.data.header.InvoiceNIT }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      DUI: <b>{{ dataProps.data.header.InvoiceDUI }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      ENTIDAD: <b>{{ dataProps.data.header.InvoiceEntity }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      MONEDA:
                      <b>{{
                        dataProps.data.header.InvoiceCurrency == "$"
                          ? "USD"
                          : ""
                      }}</b>
                    </td>
                  </tr>
                  <tr>
                    <td
                      style="
                        text-align: left;
                        vertical-align: middle;
                        width: 100%;
                        font-size: 7pt;
                      "
                    >
                      ESTADO DE FACTURA:
                      <b>{{
                        dataProps.data.header.InvoiceStatusDescription
                      }}</b>
                    </td>
                  </tr>
                </table>
                <hr />
                <table
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <!-- Itera sobre cada item en dataProps.data.body -->
                  <tr v-for="(item, index) in dataProps.data.body" :key="index">
                    <td style="width: 100%">
                      <table
                        style="
                          width: 100%;
                          font-size: 7pt;
                          border-collapse: collapse;
                        "
                      >
                        <tr>
                          <td style="text-align: left; width: 50%">
                            <b>No. Item {{ index + 1 }}</b>
                          </td>
                          <td style="text-align: right; width: 50%"></td>
                        </tr>
                        <tr>
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Cantidad
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ item.ItemQuantity }}
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Código
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ item.PrincipalBarCode || item.ID_Item }}
                          </td>
                        </tr>
                        <tr>
                          <td style="padding: 0" colspan="2">
                            <div
                              style="
                                width: 25%;
                                display: inline-block;
                                text-align: left;
                                vertical-align: top;
                              "
                            >
                              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Descripción:
                            </div>
                            <div
                              style="
                                width: 75%;
                                display: inline-block;
                                text-align: right;
                              "
                            >
                              {{ item.ItemDescription }}
                            </div>
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pre. Unitario
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              (item.ItemNoGravada > 0) ? 0 : numberWithCommas(parseFloat(item.ItemUnitPrice))
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.ItemDiscount > 0">
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Descuento
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              numberWithCommas(
                                parseFloat(item.ItemDiscount)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.ItemExenta > 0">
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas exentas
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              numberWithCommas(
                                parseFloat(item.ItemExenta)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.ItemNoSuj > 0">
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas no sujetas
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              numberWithCommas(
                                parseFloat(item.ItemNoSuj)
                              )
                            }}
                          </td>
                        </tr>
                        <tr v-if="item.ItemNoGravada > 0">
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Otros montos no afectos
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              numberWithCommas(
                                parseFloat(item.ItemNoGravada)
                              )
                            }}
                          </td>
                        </tr>
                        <tr>
                          <td style="text-align: left; width: 50%">
                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Ventas gravadas
                          </td>
                          <td style="text-align: right; width: 50%">
                            {{ dataProps.data.header.InvoiceCurrency
                            }}{{
                              numberWithCommas(
                                parseFloat(item.ItemGravada)
                              )
                            }}
                          </td>
                        </tr>
                      </table>
                    </td>
                  </tr>
                </table>
                <hr />
                <table
                  style="
                    font-size: 8pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td style="text-align: right; width: 80%">
                      Sub total de ventas
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceSubTotalVentas
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right; width: 80%">
                      Total descuentos
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalDescu
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dataProps.data.header.TurismoPorAlojamiento > 0">
                    <td style="text-align: right; width: 80%">
                      Imp. Turismo
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.TurismoPorAlojamiento
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
                    <td style="text-align: right; width: 80%">
                      IVA
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalIva
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
                    <td style="text-align: right; width: 80%">
                      Sub total
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceSubTotal
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right; width: 80%">IVA Retenido</td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceIvaRete1
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dataProps.data.header.InvoiceType == 'CCF'">
                    <td style="text-align: right; width: 80%">IVA Percebido</td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceIvaPerce1
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right; width: 80%">
                      Impuesto sobre la renta
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceReteRenta
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr v-if="dataProps.data.header.InvoiceTotalNoGravado > 0">
                    <td style="text-align: right; width: 80%">
                      Total otros montos no afectos
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }}{{
                        numberWithCommas(
                          parseFloat(
                            dataProps.data.header.InvoiceTotalNoGravado
                          )
                        )
                      }}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right; width: 80%">
                      Efectivo
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }} {{cash}}
                    </td>
                  </tr>
                  <tr>
                    <td style="text-align: right; width: 80%">
                      Cambio
                    </td>
                    <td style="text-align: right; width: 20%">
                      {{ dataProps.data.header.InvoiceCurrency
                      }} {{change}}
                    </td>
                  </tr>
                </table>
                <br />
                <table
                  style="
                    font-size: 12pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td style="text-align: right; width: 75%"><b>Total:</b></td>
                    <td style="text-align: right; width: 25%">
                      <b
                        >{{ dataProps.data.header.InvoiceCurrency
                        }}{{numberWithCommas(dataProps.data.header.InvoiceTotalPagar)}}</b
                      >
                    </td>
                  </tr>
                </table>

                <template v-if="dataProps.data.header.InvoiceInternalNote">
                  <hr />
                  <table
                    style="
                      font-size: 7pt;
                      border-collapse: collapse;
                      width: 100%;
                      vertical-align: top;
                    "
                  >
                  
                    <tr>
                      <td><b>Observaciones: </b> {{ commentsOuterHtml }}</td>
                    </tr>
                  </table>
                </template>
                <template
                  v-if="dataProps.data.header.ShowResponsabilitiesInInvoice || dataProps.data.header.InvoiceTotalPagar >= 25000" 
                  >
                  <table
                    style="
                      font-size: 7pt;
                      border-collapse: collapse;
                      width: 100%;
                      vertical-align: top;
                    "
                  >
                    <tr>
                      <td><b>Responsable por parte del receptor: </b> {{ dataProps.data.header.InvoiceExtNombEntrega }}</td>
                    </tr>
                    <tr>
                      <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuEntrega }}</td>
                    </tr>
                    <tr>
                      <td><b>Responsable por parte del emisor: </b> {{ dataProps.data.header.InvoiceExtNombRecibe }}</td>
                    </tr>
                    <tr>
                      <td><b>No. Documento: </b> {{ dataProps.data.header.InvoiceExtDocuRecibe }}</td>
                    </tr>
                  </table>
                </template>
                <div style="margin-top: 8px;">
                  <GuaranteePrintBlock
                    :html="dataProps.guaranteeHtml"
                    :business-id="dataProps.businessId"
                    :branch-id="dataProps.branchId"
                    guarantee-type="COMPROBANTE"
                    font-size="7pt"
                  />
                </div>
                <br /><br />
                <table
                  style="
                    font-size: 7pt;
                    border-collapse: collapse;
                    width: 100%;
                    vertical-align: top;
                  "
                >
                  <tr>
                    <td style="text-align: center">¡Gracias por su visita!</td>
                  </tr>
                  <!-- espacio en blanco al finalizar factura de ticket -->
                  <tr>
                    <td style="text-align: center" v-if="['d76ca00b6f45acf9815bc10e1d9b7652'].includes(keyMaster)">
                      <b>
                        NO SE ACEPTAN DEVOLUCIONES
                      </b>
                    </td>
                    <td v-else>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td>&nbsp;</td>
                  </tr>
                  <tr>
                    <td style="border-width: 2px; text-overflow: ellipsis; overflow: hidden;">
                      <div  
                        style=" width: 100%; text-align: center; text-wrap: nowrap; text-overflow: ellipsis; overflow: hidden;"
                      >
                        .....................................................................................................................
                      </div>
                    </td>
                  </tr>
                </table>
              </div>
            </div>
          </div>
        </div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import DownloadInvalidationJson from "@/components/ReportsAndPrintings/DownloadInvalidationJson.vue";
import jsPDF from "jspdf";
import QRCode from "qrcode";
import { addFormatToNIT, addFormatNRC } from "../../helpers/misc";
import { formatNumber } from "../../helpers/money";
import { numberToText } from "@/helpers/conveterNumberText.js";
import { imprimirFactura } from "../../utils/printInvoice";
import GuaranteePrintBlock from "@/components/ReportsAndPrintings/GuaranteePrintBlock.vue";

export default {
  name: "PrintPosTkFcf",
  model: {
    event: "input",
    prop: "type",
  },
  props: {
    dataProps: {
      type: Object,
    },
    hideQr: {
      type: Boolean,
      default: false,
    },
    type: {
      type: String,
      default: "",
    },
  },
  components: { DownloadInvalidationJson,
    GuaranteePrintBlock,
  },
  data() {
    return {
      header: null,
      footer: null,
      loading: false,
      numPages: 0,
      mailLabel: null,
      valuesRows: [],
      urlQr: null,
      typePrint: 0,
      keyMaster: JSON.parse(localStorage.getItem("user")).keymaster,
      ticketformat3nstar: JSON.parse(localStorage.getItem("user")).ticketformat3nstar || 0,
      ticketdirectprinting: JSON.parse(localStorage.getItem("user")).ticketdirectprinting || 0,
      cash: 0,
      change: 0,
      ShowCorrelativeControl: JSON.parse(localStorage.getItem("user")).showcorrelativecontrol,
    };
  },
  mounted() {
    this.showData()
    this.calculateTotalValues()
  },
  computed: {
    commentsOuterHtml() {
      return this.dataProps.data.header.InvoiceInternalNote.replace(
        /<[^>]*>/g,
        ""
      );
    },
    BillingNrc() {
      return addFormatNRC(this.dataProps.data.branch.BusinessBillingNRC);
    },
    BillingNit() {
      return addFormatToNIT(this.dataProps.data.branch.BusinessBillingNIT);
    },
  },
  watch: {
    "dataProps.show"() {},
  },
  methods: {
    isEnabledFlag(value) {
      return value === true || value === 1 || value === "1" || value === "true";
    },
    showData() {
      if (this.dataProps.show) {
        setTimeout(async () => {
          const partes = this.dataProps.data.header.InvoiceDate.split("/");
          const dia = partes[0];
          const mes = partes[1];
          const anio = partes[2];

          // Crear una nueva fecha en formato "yyyy-mm-dd"
          const fechaNueva = `${anio}-${mes}-${dia}`;
          const url =
            this.dataProps.data.branch.AuthFeMode == 1
              ? `https://admin.factura.gob.sv/consultaPublica?ambiente=01&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`
              : `https://admin.factura.gob.sv/consultaPublica?ambiente=00&codGen=${this.dataProps.data.header.CodigoGeneracion}&fechaEmi=${fechaNueva}`;

          // Generar el código QR y mostrarlo en el elemento con id "qrcode"

          const opt = {
            errorCorrectionLevel: "H",
            type: "image/png",
            quality: 0.3,
            margin: 1,
            color: {
              dark: "#000000",
              light: "#ffffff",
            },
            width: 100,
          };

          QRCode.toDataURL(url, opt, (error, url) => {
            if (error) {
              console.log("Error al generar el código QR:", error);
              throw error;
            }

            this.urlQr = url;
          });
          await this.getImages();
        }, 0);
      }
    },
    GetnumberToText(number) {
      if (number) return numberToText(number);
      else return "";
    },
    numberWithCommas(x) {
      if(this.keyMaster === '55652726b965155654981d279f4900bf'){
        return formatNumber(x, 4)
      } 
      return formatNumber(x)
    },
    /*getHeaderFooter() {
          let search = {};
          search.ID_business = JSON.parse(localStorage.getItem("user")).businessid || ""
          search.ID_branch = JSON.parse(localStorage.getItem("user")).branch || ""
          this.$API.HF.getHF(search).then((data) => {
              let header = [], footer = [];
              header = data.filter((x) => x.State == '1' && x.Type == 'Header');
              this.header = header.length > 0 ? JSON.parse(header[0].Body).html : '';
              this.header = this.header.replace(/(\n)/gm, "");
              footer = data.filter((x) => x.State == '1' && x.Type == 'Footer');
              this.footer = footer.length > 0 ? JSON.parse(footer[0].Body).html : '';
          })
      },*/

    /*calculatePagesOfDoc() {
          let pages = 0
          let rows = 0
          this.valuesRows[pages] = []

          try{
              if(this.dataProps.data.branch.BusinessBillingNRC == '3213715' || this.dataProps.data.branch.BusinessBillingNRC == '2201050') {
                  this.typePrint = 1
                  //One page
                  if(this.dataProps.data.body.length <= 24){
                      for(let i = 0; i < this.dataProps.data.body.length; i++){
                          rows++
                          this.valuesRows[pages].push(this.dataProps.data.body[i])
                      }    
                  }
                  else{
                      for(let i = 0; i < this.dataProps.data.body.length; i++){
                          if(rows < 29 && (i !== this.dataProps.data.body.length - 1)){
                              rows++
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                          }
                          else if(rows <= 24){
                              rows++
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                          }
                          else{
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                              pages++
                              rows = 0
                              this.valuesRows[pages] = []
                          }
                      }
                  }
              }
              else{
                  this.typePrint = 0
                  //Cuando es solo una página
                  if(this.dataProps.data.body.length <= 34){
                      for(let i = 0; i < this.dataProps.data.body.length; i++){
                          rows++
                          this.valuesRows[pages].push(this.dataProps.data.body[i])
                      }    
                  }
                  else{
                      for(let i = 0; i < this.dataProps.data.body.length; i++){
                          if(rows < 39 && (i !== this.dataProps.data.body.length - 1)){
                              rows++
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                          }
                          else if(rows <= 34){
                              rows++
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                          }
                          else{
                              this.valuesRows[pages].push(this.dataProps.data.body[i])
                              pages++
                              rows = 0
                              this.valuesRows[pages] = []
                          }
                      }
                  }
              }
              
          }
          catch(err) {
              alert(err)
          }
          pages = pages + 1
          this.numPages = pages
      },*/

    async Print() {

      
      if (this.isEnabledFlag(this.ticketdirectprinting)) {
        this.loading = true;
        await imprimirFactura(this.dataProps.data.header.ID_Invoice, this);
        this.loading = false;
        return true
      }

      this.loading = true;

      var properties = {}

      var toScale = 0.698

      /*var pdfWidth = 0

      if (this.ticketformat3nstar) {
        pdfWidth = 76 * 2.83465
      }
      else if (this.keyMaster == "" || this.keyMaster == "") {
        pdfWidth = 72.1 * 2.83465
      } else {
        pdfWidth = 8 * 28.35;
      }

      const pdfHeight = this.$refs.dataprint.clientHeight * 0.75
      
      properties = {
        orientation: "p",
        unit: "pt",
        format: [pdfWidth, pdfHeight],
      }*/



      if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
        const pdfWidth = 72.1 * 2.83465
        const pdfHeight = 210 * 2.83465
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        }
      } 
      else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
        const pdfWidth = 72.1 * 2.83465
        const pdfHeight = 297 * 2.83465
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        }
        toScale = 0.675
      }
      // Autostyle.
      else if (this.keyMaster == "fdea701deefc2f8a21a9dfcd2b5166ca" || this.keyMaster == 'fe9f16b15a2d0bc1ad64a56efb4abfda' 
      || this.keyMaster == '579a13b4a79db357b608b247053fc89d' || this.keyMaster == 'cc8a8458a6b9a580a055095006d2de66' || this.keyMaster == 'e9aaa6a6458a982a4b01c253a76ae58d' 
      || this.keyMaster == 'b5df5bc0d3cbf62c52817e7bddc09ff3' || this.keyMaster == '9593c3ca31b86c09c9b764c5baddf846' || this.ticketformat3nstar) {
        const pdfWidth = 76 * 2.83465
        var pdfHeight = 297 * 2.83465

        if (this.keyMaster == '579a13b4a79db357b608b247053fc89d') {
          pdfHeight = 400 * 2.83465
        }

        if (this.keyMaster == 'ac7d98c7e5d0db964018ac969140297c') {
          pdfHeight = this.$refs.dataprint.clientHeight * 0.75
        }

        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        }
        toScale = 0.675
      }
      else {
        const pdfWidth = 8 * 28.35;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, 400],
        }
      }

      var doc = new jsPDF(properties);

      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: toScale,
          //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      //doc.deletePage(2)

      doc.autoPrint({ variant: "non-conform" });
      const blob = doc.output("bloburl");
      window.open(blob);

      this.loading = false;
    },

    async Download() {
      this.loading = true;

      var properties = {}

      var toScale = 0.698

      if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
        const pdfWidth = 72.1 * 2.83465
        const pdfHeight = 210 * 2.83465
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        }
      } 
      else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
        const pdfWidth = 72.1 * 2.83465
        const pdfHeight = 297 * 2.83465
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, pdfHeight],
        }
        toScale = 0.675
      }
      else {
        const pdfWidth = 8 * 28.35;
        properties = {
          orientation: "p",
          unit: "pt",
          format: [pdfWidth, 400],
        }
      }

      var doc = new jsPDF(properties);

      doc.setFont("arial")
      await doc.html(this.$refs.dataprint, {
        callback: function (doc) {
          doc.output();
        },
        x: 0,
        y: 0,
        margin: [0, 0, 0, 0],
        html2canvas: {
          scale: toScale,
          //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
          useCORS: true,
          logging: false,
          allowTaint: true,
        },
      });

      //doc.deletePage(2)
      doc.save(
        this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".pdf"
      ); //Agregado por Juan 13082023

      this.loading = false;
    },
    async sendMail() {
      try {
        this.mailLabel = null;
        this.mailLabel = "Enviando...";
        
        var properties = {}

        var toScale = 0.698

        if (this.keyMaster == "7fb536861eb4faca5ebe690424ce6371") {
          const pdfWidth = 72.1 * 2.83465
          const pdfHeight = 210 * 2.83465
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, pdfHeight],
          }
        }
        else if (this.keyMaster == "679f296532b2e6338c68854d96282b42") {
          const pdfWidth = 72.1 * 2.83465
          const pdfHeight = 297 * 2.83465
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, pdfHeight],
          }
          toScale = 0.675
        } 
        else {
          const pdfWidth = 8 * 28.35;
          properties = {
            orientation: "p",
            unit: "pt",
            format: [pdfWidth, 400],
          }
        }

        var doc = new jsPDF(properties);
        await doc.html(this.$refs.dataprint, {
          callback: function (doc) {
            doc.output();
          },
          x: 0,
          y: 0,
          margin: [0, 0, 0, 0],
          html2canvas: {
            scale: toScale,
            //scale: (doc.internal.pageSize.width - 10 * 2) / this.$refs.dataprint.scrollWidth,
            useCORS: true,
            logging: false,
            allowTaint: true,
          },
        });

        this.assignCuerpoDocumento();

        const {
          data: {
            header: { jsonMH },
            dteJson: { ID_Invoice },
          },
        } = this.dataProps;

        const body = {
          dtefilebuffer: new Buffer.from(doc.output("arraybuffer")),
          dtejson: { ...jsonMH, ID_Invoice },
          dtefilebufferfilename:
            this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', ""),
        };

        this.$API.invoices.sendInvoiceMail(body);

        this.mailLabel = "Se envió el correo correctamente";
        this.$emit("mailSent");
      } catch (error) {
        this.mailLabel = "Ocurrió un error al enviar el correo";
        console.log(error);
      }
    },
    assignCuerpoDocumento() {
      this.dataProps.data.header.jsonMH.cuerpoDocumento =
        this.dataProps.data.body.map((item, index) => ({
          descripcion: item.ItemDescription,
          montoDescu: item.ItemDiscount,
          codigo: item.ID_Item,
          ventaGravada: item.ItemGravada,
          ivaItem: item.ItemIva,
          ventaNoSuj: item.ItemNoSuj,
          ventaExenta: item.ItemExenta,
          // "tributos": null,
          numItem: index + 1,
          noGravado: item.ItemNoGravada,
          psv: item.ItemPsv,
          // "tipoItem": 3,
          // "codTributo": null,
          uniMedida: item.ItemMeasureUnit,
          // "numeroDocumento": null,
          cantidad: item.ItemQuantity,
          precioUni: item.ItemUnitPrice,
        }));
    },
    async downLoadJSON() {
      try {
        const selloRecibido = JSON.parse(
          this.dataProps.data.header.ResponseMhJson
        ).selloRecibido;
        const firmaElectronica =
          this.dataProps.data.header.JsonMhSigned.documento;
        const jsonToSend = {
          ...this.dataProps.data.header.JsonMh.dteJson,
          firmaElectronica,
          selloRecibido,
        };
        delete jsonToSend.passwordPri;

        const aElement = document.createElement("a");
        aElement.setAttribute(
          "download",
          this.dataProps.data.header.ID_Invoice +
            "_" +
            this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
            "_" +
            this.dataProps.data.header.InvoiceName.replaceAll(
              /[:/<>*|/]/g,
              ""
            ).replaceAll('\\"', "") +
            ".pdf"
        );
        this.assignCuerpoDocumento();
        const blob = new Blob([JSON.stringify(jsonToSend)], {
          type: "application/json",
        });
        const href = URL.createObjectURL(blob);
        aElement.href = href;
        aElement.download =
          this.dataProps.data.header.ID_Invoice +
          "_" +
          this.dataProps.data.header.InvoiceDate.replaceAll("/", "-") +
          "_" +
          this.dataProps.data.header.InvoiceName.replaceAll(
            /[:/<>*|/]/g,
            ""
          ).replaceAll('\\"', "") +
          ".json";
        aElement.click();
        URL.revokeObjectURL(href);
      } catch (error) {
        this.mailLabel = "Ocurrió un error al descargar JSON";
        console.log(error);
      }
    },
    async getImages() {
      const logo = this.dataProps.data.branch.BranchLogoPath;

      if (logo) {
        const LogoBranchBase64 = localStorage.getItem("LogoBranchBase64")

        if (LogoBranchBase64) {
          this.dataProps.data.branch.BranchLogoPath = `${LogoBranchBase64}`;
        }
        else {
          const { imageBase64: logoImageBase64 } = await this.$API.utilities.getImageInBase64({ file: logo });
          this.dataProps.data.branch.BranchLogoPath = `${logoImageBase64}`;
        }
      }
    },
    calculateTotalValues() {
      const invoicePayments = this.dataProps.data.invoicePayments || []
      const isHistoryFlow = invoicePayments.some((payment) => (
        Object.prototype.hasOwnProperty.call(payment, "DescriptionTypePayment") ||
        Object.prototype.hasOwnProperty.call(payment, "TotalPayment")
      ));
      const resolvePaymentCode = (payment) => {
        const code = payment?.typePayment
          ?? payment?.TypePayment
          ?? payment?.Codigo
          ?? payment?.codigo
          ?? payment?.code
          ?? payment?.Code;

        if (code !== undefined && code !== null && String(code).trim() !== "") {
          return String(code);
        }
        
        const description = String(
          payment?.descriptionPayment
          ?? payment?.DescriptionTypePayment
          ?? payment?.description
          ?? ""
        ).toLowerCase();

        return description.includes("billetes y monedas") ? "01" : "";
      };

      const resolvePaymentAmount = (payment) => {
        const value = payment?.totalPayment ?? payment?.TotalPayment ?? 0;
        const numericValue = Number(value);
        return Number.isFinite(numericValue) ? numericValue : 0;
      };

      const cashAmount = invoicePayments.reduce((sum, payment) => (
        resolvePaymentCode(payment) === "01"
          ? sum + resolvePaymentAmount(payment)
          : sum
      ), 0);

      const changeAmount = Number(this.dataProps.data.header.MoneyReturn || 0);
      this.change = parseFloat(changeAmount.toFixed(2));
      this.cash = parseFloat(
        (isHistoryFlow ? cashAmount + changeAmount : cashAmount).toFixed(2)
      );

      if (!invoicePayments.length && this.dataProps.data.header.InvoicePaymentType) {
        this.cash = parseFloat(
          Number(this.dataProps.data.header.InvoiceMontoTotalOperacion || 0).toFixed(2)
        );
      }
    }
  },
};
</script>

<style scoped>
.u-row .u-col-100 {
  width: 100% !important;
}
.btnclean {
  border-radius: 15px;
  border: 1px solid white;
  background-color: #f29d35 !important;
  color: white !important;
}
.btnclose {
  border-radius: 15px;
  border: 1px solid white;
  background-color: rgb(255, 38, 38) !important;
  color: white !important;
}

* {
  font-family: Arial, Helvetica, sans-serif !important;
  letter-spacing: 0.01px;
}
</style>
